export const identity = <T>(d: T): T => d;
